import fun from "../../../util/util";
import myConst from "@/util/my-const";
export default {
    namespaced:true,
    state:{
        statId:"",//电站id(电站的选中值)
        statMenuList:[],//电站私有菜单
        statMenuSeVal:"", //电站菜单选中值
        staName:"", //电站名称
        devId:null, //设备id
        devType:null //设备类型
    },
    mutations:{
        //设置电站的选中值
        setStatId(state,val){
            state.statId = val
        },
        // 设置设备id
        setDevId(state,val){
            state.devId = val
        },
        // 设置设备类型
        setDevType(state,val){
            state.devType = val
        },
        //设置电站名称
        setStatName(state,val){
            state.staName = val
        },

        //设置电站菜单的选中值
        setStatMenuSelVal(state,id){
            state.statMenuSeVal = id
        },

        //设置电站的私有菜单列表
        setStatMenuList(state,list){
            state.statMenuList = list
        },

        clearStatMent(state){
            state.statId = "",
                state.statMenuList ="",
                state.statMenuSeVal = ""
            state.devId = ''
            state.devType = ''
            state.staName = ''
        }
    },
    getters:{
        //获取电站的私有菜单
        getStationMenu(state){
            return state.statMenuList
        }
    }

}
